import styled from '@emotion/styled'
import {
  Flex,
  FlexItem,
  HelpIcon,
  Panel,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M,
  TooltipUtils
} from 'mailup-web-components'
import {
  ACTION_MOVE_COPY,
  ACTION_SEND_MESSAGE,
  ACTION_SEND_SMS,
  senderConfigState,
  taskState
} from 'Pages/Task/recoil/state/task'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilState, useSetRecoilState } from 'recoil'

const StyledHelpIcon = styled(HelpIcon)`
  margin-left: -4px !important;
  svg {
    top: 2px !important;
  }
`

const ActionRadio = ({ check, condition, setCheck, label, toolTip }) => {
  const intl = useIntl()
  const setIdMessage = useSetRecoilState(senderConfigState)
  useEffect(() => {
    toolTip && TooltipUtils.rebuild()
  }, [])

  return (
    <FlexItem>
      <RadioButton
        value={condition}
        checked={check === condition}
        labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
        label={intl.formatMessage({
          id: label
        })}
        onChange={() => {
          setCheck((prev) => ({
            ...prev,
            isDirtyDetailAction: true,
            Detail: {
              ...prev.Detail,
              Action: condition
            }
          }))
          setIdMessage((prev) => ({
            ...prev,
            IdMessage: 0,
            idMessageIsDirty: false
          }))
        }}
        data-mu-test={`task-2-radio-${condition}`}
      />
      {toolTip && (
        <StyledHelpIcon
          text={intl.formatMessage({
            id: toolTip
          })}
        />
      )}
    </FlexItem>
  )
}

export const ActionToExecute = () => {
  const intl = useIntl()
  const [task, setCheck] = useRecoilState(taskState)

  return (
    <Panel>
      <Title variant={TITLE_VARIANT_M}>
        {intl.formatMessage({ id: 'Load.Task.ActionsGeneralPanelTitle' })}
      </Title>
      <SpacingVertical />
      <Flex width='100%' columnGap='48px'>
        <ActionRadio
          check={task.Detail.Action}
          condition={ACTION_SEND_MESSAGE}
          setCheck={setCheck}
          label='Load.Task.ActionsEmail'
        />

        <ActionRadio
          check={task.Detail.Action}
          condition={ACTION_SEND_SMS}
          setCheck={setCheck}
          label='Load.Task.ActionsSMS'
        />

        <ActionRadio
          check={task.Detail.Action}
          condition={ACTION_MOVE_COPY}
          setCheck={setCheck}
          label='Load.Task.ActionsSegment'
          toolTip='Load.Task.ActionsSegmentTooltip'
        />
      </Flex>
    </Panel>
  )
}

ActionRadio.propTypes = {
  check: PropTypes.number,
  condition: PropTypes.number,
  setCheck: PropTypes.func,
  label: PropTypes.string,
  toolTip: PropTypes.string
}
